import React, { useState, useContext, useEffect } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { useWallet } from 'use-wallet'
import { fromUtf8 } from 'web3-utils'
import { ethers } from 'ethers'
import ReactTooltip from 'react-tooltip'
import { ToastContainer, toast } from 'react-toastify'
import Container from 'components/Container'
import moment from 'moment'

import Modal from 'components/Modal'
import ModalTitle from 'components/ModalTitle'
import ModalContent from 'components/ModalContent'
import ModalActions from 'components/ModalActions'
import Button from 'components/Button'
import Input from 'components/Input'
import Spinner from 'react-svg-spinner'
import Label from 'components/Label'

import { AccountContext } from 'contexts/AccountProvider'
import CurrencySearch from 'components/CurrencySearch'
import Spacer from 'components/Spacer'
import Selector from 'components/Selector'

import { getTokenEtherFromWeiByAddress } from 'lottery/util'
import {
  viewTranscationURL,
  poolsAddress,
  tokenAddress as ubetTokenAddress,
} from 'lottery/constants'

const CreateNewPoolModal = ({ onDismiss, history }) => {
  const { poolsContract, getToken, getAllowance } = useContext(AccountContext)
  const { account } = useWallet()
  const [rewardToken, setRewardToken] = useState('')
  const [poolName, setPoolName] = useState('')
  const [tokenAddress, setTokenAddress] = useState(null)
  const [tokenName, setTokenName] = useState('')
  const [tokenDecimal, setTokenDecimal] = useState(0)
  const [tokenEnough, setTokenEnough] = useState(true)
  const [rateExchange, setRateExchange] = useState(1)
  const [offeringAmount, setOfferingAmount] = useState(1)
  const [weight, setWeight] = useState(0)
  const [saleExpiry, setSaleExpiry] = useState(moment().format('ll LT'))
  const [openMenu, setOpenMenu] = useState(false)
  const [errMessage, setErrMessage] = useState()
  const [loading, setLoading] = useState(false)
  const [hashLink, setHashLink] = useState('')
  const [appTokenName, setAppTokenName] = useState('')
  const [appTokenEnough, setAppTokenEnough] = useState(true)
  const [tokenApproved, setTokenApproved] = useState(false)
  const [appTokenApproved, setAppTokendApproved] = useState(false)

  useEffect(() => {
    getAppTokenInfo()
    checkUbetTokenAllowance(weight)
  }, [])

  const getAppTokenInfo = async () => {
    const appToken = await getToken(ubetTokenAddress)
    if (!appToken) {
      return
    }
    const tokenName = await appToken.methods.symbol().call()
    setAppTokenName(tokenName)
  }

  const checkUbetTokenAllowance = async (weight) => {
    const allowance = await getAllowance(ubetTokenAddress)
    if (
      !allowance ||
      Number(allowance) < BigNumber(1e18).times(Number(weight)).toFixed(0)
    ) {
      setAppTokendApproved(false)
      return
    }
    setAppTokendApproved(true)
  }

  const checkCustomTokenAllowance = async (
    tokenAddress,
    offeringAmount,
    decimal
  ) => {
    const allowance = await getAllowance(tokenAddress)
    if (
      !allowance ||
      Number(allowance) < Math.pow(10, decimal) * offeringAmount
    ) {
      setTokenApproved(false)
      return
    }
    setTokenApproved(true)
  }

  const approveToken = async (tokenAddress) => {
    setLoading(true)
    const token = await getToken(tokenAddress)
    if (!token) {
      return
    }
    const tx = await token.methods
      .approve(poolsAddress, ethers.constants.MaxUint256.toString())
      .send({ from: account })
    if (!!tx && tx.status == true) {
      setLoading(true)
      if (tokenAddress === ubetTokenAddress) {
        checkUbetTokenAllowance(weight)
      } else {
        checkCustomTokenAllowance(tokenAddress, offeringAmount, tokenDecimal)
      }
    }
  }

  const checkAccountBalance = (balance, decimal, offeringAmount, weight) => {
    if (
      balance <
      new BigNumber(10).pow(decimal) * Number(offeringAmount) * weight
    ) {
      return false
    }
    return true
  }

  const handleCreateNewPool = async () => {
    if (isNaN(weight)) {
      setErrMessage('Weight should be number')
      return
    }

    if (isNaN(rateExchange)) {
      setErrMessage('Exchange rate should be number')
      return
    }

    if (isNaN(offeringAmount)) {
      setErrMessage('Offering amount should be number')
      return
    }

    if (isNaN(saleExpiry)) {
      setErrMessage('Sale expiry should be number')
      return
    }

    if (!rewardToken) {
      setErrMessage('You should select token')
      return
    }

    if (!poolName) {
      setErrMessage('You should fill pool name')
      return
    }

    /*   if (saleExpiry < 100) {
      setErrMessage('Sale Expiry should be at least 100')
      return
    } */

    const transectionSuccess = () => {
      return (
        <div>
          Your pool has been created successfully!{' '}
          <a href={hashLink} target="_blank">
            View Transaction
          </a>
        </div>
      )
    }

    setLoading(true)
    setErrMessage('')
    const assitantNumber = Math.pow(
      10,
      Number(tokenDecimal) - rewardToken?.decimals
    )
    const exchangeRate = BigNumber(1e18)
      .times(rateExchange)
      .times(assitantNumber)
      .toFixed(0)
    const expireDate = new Date(saleExpiry)
    const expiry = (expireDate - new Date()) / 1000

    poolsContract.methods
      .openNewPool(
        tokenAddress,
        rewardToken.address,
        exchangeRate,
        getTokenEtherFromWeiByAddress(rewardToken, offeringAmount),
        BigNumber(1e18).times(Number(weight)).toFixed(0),
        expiry,
        fromUtf8(poolName)
      )
      .send({ from: account })
      .on('transactionHash', (tx) => {
        setHashLink(viewTranscationURL + tx)
        // return tx
      })
      .on('confirmation', (confirmationNumber, receipt) => {
        const pid = receipt.events.PoolNameChange.returnValues.poolId
        if (confirmationNumber === 2 && receipt.status === true) {
          toast(transectionSuccess)
          setLoading(false)
        }
        history.push(`pools/${pid}`)
        //window.location.reload(false)
      })
  }

  const checkCustomTokenBalance = async (token, tokenName, offeringAmount) => {
    const tokenBalance = await token.methods.balanceOf(account).call()
    const tokenDecimal = await token.methods.decimals().call()
    !checkAccountBalance(tokenBalance, tokenDecimal, offeringAmount, 1) &&
      setTokenEnough(false)
    checkAccountBalance(tokenBalance, tokenDecimal, offeringAmount, 1) &&
      setTokenEnough(true)
  }

  const checkUbetTokenBalance = async (offeringAmount, weight) => {
    const ubetToken = await getToken(ubetTokenAddress)
    if (!ubetToken) {
      return
    }
    const tokenBalance = await ubetToken.methods.balanceOf(account).call()
    const tokenDecimal = await ubetToken.methods.decimals().call()
    !checkAccountBalance(tokenBalance, tokenDecimal, offeringAmount, weight) &&
      setAppTokenEnough(false)
    checkAccountBalance(tokenBalance, tokenDecimal, offeringAmount, weight) &&
      setAppTokenEnough(true)
  }

  const handleChangeTokenAddress = async (e) => {
    const tokenAddress = e.target.value
    setTokenAddress(tokenAddress)
    const token = await getToken(tokenAddress)
    if (!token) {
      setErrMessage('Invalid token adddress')
      setTokenName('')
      return
    }
    const tokenName = await token.methods.symbol().call()
    setTokenName(tokenName)
    const tokenDecimal = await token.methods.decimals().call()
    setTokenDecimal(tokenDecimal)
    setErrMessage('')
    offeringAmount && checkCustomTokenBalance(token, tokenName, offeringAmount)
    offeringAmount &&
      checkCustomTokenAllowance(tokenAddress, offeringAmount, tokenDecimal)
  }
  const handleChangeWeight = (e) => {
    const weight = e.target.value
    setWeight(weight)
    checkUbetTokenBalance(offeringAmount, weight)
    checkUbetTokenAllowance(weight)
  }
  const handleChangeOfferingAmount = async (e) => {
    const offeringAmount = e.target.value
    setOfferingAmount(offeringAmount)
    const token = await getToken(tokenAddress)
    if (!token) {
      setTokenName('')
      return
    }
    const tokenName = await token.methods.symbol().call()
    const tokenDecimal = await token.methods.decimals().call()
    checkCustomTokenBalance(token, tokenName, offeringAmount)
    checkUbetTokenBalance(offeringAmount, weight)
    checkCustomTokenAllowance(tokenAddress, offeringAmount, tokenDecimal)
  }

  const handleChangeTokenName = (e) => setTokenName(e.target.value)
  const handleChangeSaleExpiry = (date) => {
    setSaleExpiry(moment(date).format('ll LT'))
  }
  const handleChangePoolName = (e) => setPoolName(e.target.value)
  const handleChangeRateExchange = (e) => setRateExchange(e.target.value)

  const handleOpenSelector = () => {
    setOpenMenu(true)
  }

  const handleCloseSelector = () => {
    setOpenMenu(false)
  }

  return (
    <Modal createPool={!openMenu}>
      {openMenu ? (
        <CurrencySearch
          selectedCurrency={rewardToken}
          onCurrencySelect={setRewardToken}
          handleBlack={handleCloseSelector}
        />
      ) : (
        <div>
          <ModalTitle text="Create New Pool" />
          <ModalContent>
            <StyledWrapper>
              <Input
                startAdornment="Token Address"
                value={tokenAddress}
                onChange={handleChangeTokenAddress}
                tooltip="Address of the token you are offering for sale."
              />

              <Spacer />
              <Input
                startAdornment="Token Name"
                value={tokenName}
                disabled={true}
                onChange={handleChangeTokenName}
                tooltip="If the token name doesn't match the one you are offering, <br/>
                double-check the address. "
              />
              <Spacer />
              <Input
                startAdornment="Pool Name"
                value={poolName}
                onChange={handleChangePoolName}
              />
              <Spacer />
              <Selector
                handleOpenMenu={handleOpenSelector}
                placeholder="Select Token"
                selectedOption={rewardToken}
                startAdornment="Token Type"
                tooltip="Select the token you'd like to get in exchange of offering your token."
              />
              <Spacer />
              <Input
                startAdornment="Exchance Rate"
                value={rateExchange}
                onChange={handleChangeRateExchange}
                tooltip="Specify the exchange rate. For example,  <br/>
								if you are selling token ABC at 0.03 ETH, you should <br />
                enter 0.03 here. Double-check the exchange ratio below: "
              />
              {tokenName && rateExchange && rewardToken && (
                <>
                  <Spacer />
                  <p className="conversion-info">
                    1 {tokenName} : {rateExchange} {rewardToken?.symbol}
                  </p>
                </>
              )}
              <Spacer />
              <Input
                startAdornment="Offering Amount"
                value={offeringAmount}
                onChange={handleChangeOfferingAmount}
                tooltip="Specify the amount of token you are offering for sale."
              />
              <Spacer />
              <Input
                startAdornment="Weight"
                value={weight}
                onChange={handleChangeWeight}
                tooltip="This is the cost in UBET you'll have to pay to create your token sale pool.  <br/>
								We take any amount, including zero. The higher your weight is,  <br/>
								the higher your pool ranks on home page. If your weight is higher than 100, <br />
                you'll be able to customize the intro, where you can promote your token."
              />
              <Spacer />
              <Input
                startAdornment="Sale Expiry"
                value={saleExpiry}
                disabled={true}
                onChange={handleChangeSaleExpiry}
                tooltip="Set the expiration date in your local time zone. Users won't be able to purchase after this date time. "
              />
            </StyledWrapper>
            <Spacer />
            {loading ? (
              <div style={{ width: '100%', textAlign: 'center' }}>
                <Spinner />
                <Label size="12" text="Waiting for the transaction" />
              </div>
            ) : (
              <></>
            )}
            <StyledInfo>{errMessage}</StyledInfo>
            {!appTokenEnough && !tokenEnough && (
              <StyledInfo>
                You don't have enough {appTokenName}, {tokenName} balance
              </StyledInfo>
            )}
            {!appTokenEnough && tokenEnough && (
              <StyledInfo>
                You don't have enough {appTokenName} balance
              </StyledInfo>
            )}
            {!tokenEnough && appTokenEnough && (
              <StyledInfo>You don't have enough {tokenName} balance</StyledInfo>
            )}
          </ModalContent>
          <Container size="sm">
            <p>
              <strong>
                Please note that we take 1% fees, on top of that, when/if there
                is a referral, the referrer takes 1% commission, and another 1%
                goes to the referrer with the highest sales.{' '}
              </strong>
            </p>
            <p>
              You Bet! provides the service that allows eligible entities to
              create their own token sales. It is such entity's own
              responsibility to know whether you are eligible to run it.
              Unfortunately, since our service is fully decentralized, the
              technology is not available for You Bet! to help you find out
              whether you are eligible. We are not responsible for pool owner's
              behavior.{' '}
            </p>
          </Container>
          {!!weight && (
            <ModalActions>
              <Button
                text={`Approve ${appTokenName} ${appTokenApproved ? '✔️' : ''}`}
                variant="secondary"
                disabled={appTokenApproved}
                onClick={() => approveToken(ubetTokenAddress)}
              />
            </ModalActions>
          )}
          {tokenName && (
            <ModalActions>
              <Button
                text={`Approve ${tokenName} ${tokenApproved ? '✔️' : ''}`}
                variant="secondary"
                disabled={tokenApproved}
                onClick={() => approveToken(tokenAddress)}
              />
            </ModalActions>
          )}
          <ModalActions>
            <Button
              text="Create"
              variant="secondary"
              disabled={!tokenApproved || !appTokenApproved}
              onClick={handleCreateNewPool}
            />
          </ModalActions>
          <ToastContainer />
        </div>
      )}
      <ReactTooltip
        id="soclose"
        effect="solid"
        className="tooltip-class"
        delayHide={500}
        delayUpdate={500}
        place="right"
        type="dark"
      />
    </Modal>
  )
}

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 422px;
`

const StyledInfo = styled.h4`
  color: ${(props) => props.theme.color.primary.main};
  font-size: 12px;
  text-align: center;
  margin: 0px;
`

export default CreateNewPoolModal
